import React, { useState, useEffect } from 'react';
import { Card } from 'components/common';
import PropTypes from 'prop-types';
import { FiUsers } from 'react-icons/fi';
import apiAxios from 'helpers/apiAxios';

const ContractHandleSummary = ({ baseParams }) => {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!baseParams) return;
    let cancelled = false;
    setLoading(true);
    apiAxios.get('/crm/dashboard/contracts/get_released_by_data', { params: baseParams })
      .then(res  => { if (!cancelled) setData(res.data?.data || []); })
      .catch(()  => { if (!cancelled) setData([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [baseParams]);

  if (!loading && data.length === 0) return null;

  const totalContracts  = data.reduce((s, r) => s + (r.contract_count  || 0), 0);
  const totalAddendums  = data.reduce((s, r) => s + (r.addendum_count  || 0), 0);
  const totalAll        = totalContracts + totalAddendums;

  return (
    <Card className="tw-border tw-border-gray-200 tw-shadow-sm">
      <div className="tw-px-5 tw-py-3 tw-border-b tw-border-gray-100 tw-flex tw-items-center tw-gap-2">
        <FiUsers size={15} className="tw-text-blue-500" />
        <h3 className="tw-font-bold tw-text-gray-900 tw-text-sm">Handle Summary</h3>
        <span className="tw-text-xs tw-text-gray-400">by Released By</span>
      </div>

      {loading ? (
        <div className="tw-px-5 tw-py-4 tw-animate-pulse">
          <div className="tw-h-4 tw-bg-gray-100 tw-rounded-sm tw-w-full tw-mb-2" />
          <div className="tw-h-4 tw-bg-gray-100 tw-rounded-sm tw-w-3/4 tw-mb-2" />
          <div className="tw-h-4 tw-bg-gray-100 tw-rounded-sm tw-w-2/3" />
        </div>
      ) : (
        <div className="tw-overflow-x-auto">
          <table className="tw-w-full tw-text-xs tw-border-collapse">
            <thead>
              <tr className="tw-bg-gray-50">
                <th className="tw-text-left tw-px-4 tw-py-2 tw-font-semibold tw-text-gray-500 tw-border-b tw-border-gray-100 tw-w-1/3">Handle By</th>
                <th className="tw-text-center tw-px-4 tw-py-2 tw-font-semibold tw-text-blue-600 tw-border-b tw-border-gray-100">Contracts</th>
                <th className="tw-text-center tw-px-4 tw-py-2 tw-font-semibold tw-text-amber-600 tw-border-b tw-border-gray-100">Addendums</th>
                <th className="tw-text-center tw-px-4 tw-py-2 tw-font-semibold tw-text-gray-700 tw-border-b tw-border-gray-100">Total</th>
              </tr>
            </thead>
            <tbody>
              {data.map((r, i) => {
                const total = (r.contract_count || 0) + (r.addendum_count || 0);
                return (
                  <tr key={i} className="hover:tw-bg-slate-50 tw-transition-colors">
                    <td className="tw-px-4 tw-py-2 tw-border-b tw-border-gray-50 tw-text-gray-800">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <span className="tw-w-6 tw-h-6 tw-rounded-xl tw-bg-blue-100 tw-text-blue-700 tw-text-xs tw-font-bold tw-flex tw-items-center tw-justify-center tw-shrink-0">
                          {(r.released_by || '?')[0].toUpperCase()}
                        </span>
                        <span className="tw-font-medium tw-truncate">{r.released_by || '—'}</span>
                      </div>
                    </td>
                    <td className="tw-px-4 tw-py-2 tw-border-b tw-border-gray-50 tw-text-center tw-font-semibold tw-text-blue-600">{r.contract_count || 0}</td>
                    <td className="tw-px-4 tw-py-2 tw-border-b tw-border-gray-50 tw-text-center tw-font-semibold tw-text-amber-600">{r.addendum_count || 0}</td>
                    <td className="tw-px-4 tw-py-2 tw-border-b tw-border-gray-50 tw-text-center tw-font-bold tw-text-gray-800">{total}</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr className="tw-bg-gray-50">
                <td className="tw-px-4 tw-py-2 tw-font-bold tw-text-gray-700">Total</td>
                <td className="tw-px-4 tw-py-2 tw-text-center tw-font-bold tw-text-blue-700">{totalContracts}</td>
                <td className="tw-px-4 tw-py-2 tw-text-center tw-font-bold tw-text-amber-700">{totalAddendums}</td>
                <td className="tw-px-4 tw-py-2 tw-text-center tw-font-bold tw-text-gray-900">{totalAll}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </Card>
  );
};

ContractHandleSummary.propTypes = {
  baseParams: PropTypes.object
};
ContractHandleSummary.defaultProps = { baseParams: null };

export default ContractHandleSummary;
